import { render } from "./ProjectPersonsComponent.vue?vue&type=template&id=098735fd&scoped=true"
import script from "./ProjectPersonsComponent.vue?vue&type=script&lang=js"
export * from "./ProjectPersonsComponent.vue?vue&type=script&lang=js"

import "./ProjectPersonsComponent.vue?vue&type=style&index=0&id=098735fd&scoped=true&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098735fd"]])

export default __exports__